import createSizePropertyCheck from "./_createSizePropertyCheck.js";
import getByteLength from "./_getByteLength.js";
export default createSizePropertyCheck(getByteLength);
